module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e02b47da60ad2adf5b94b2633fe859c3.png";